import {callBackendApi} from "../../../components/service/axios";

export const fetchMembersMatchingConditionList = async (page, size, condition) => {
    return await callBackendApi("post", "/bff/members", {condition: condition}, {
        page: page,
        size: size
    });
};
